var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkenin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1514 31.5987V31.5974H33.1595V20.1921C33.1595 14.6125 31.9001 10.3145 25.0608 10.3145C21.7729 10.3145 19.5665 12.0352 18.6658 13.6666H18.5706V10.8354H12.0859V31.5974H18.8383V21.3168C18.8383 18.6099 19.3763 15.9925 22.8911 15.9925C26.3542 15.9925 26.4058 19.0816 26.4058 21.4904V31.5987H33.1514Z",
    fill: "#0676a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08984 10.8364H7.85034V31.5985H1.08984V10.8364Z",
    fill: "#0676a8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46832 0.5C2.30673 0.5 0.552734 2.17283 0.552734 4.23439C0.552734 6.29595 2.30673 8.00377 4.46832 8.00377C6.62991 8.00377 8.38391 6.29595 8.38391 4.23439C8.38255 2.17283 6.62855 0.5 4.46832 0.5V0.5Z",
    fill: "#0676a8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkenin);
export default __webpack_public_path__ + "static/media/linkenin.52701b33b4fd6478e41f36659403462d.svg";
export { ForwardRef as ReactComponent };